



















import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  ['blockquote', 'code-block'],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction

  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image'],
  ['clean'], // remove formatting button
];

@Component({
  components: {
    quillEditor,
  },
})
export default class BaseInfo extends Vue {
  @Watch('content', { deep: true })
  handlers(val) {
    this.$emit('onEditorChange', val);
    this.$store.commit('INFO',val);
  }
  @Prop(Object) info!: object;
  @Watch('info', {immediate:true, deep: true })
  handchang(val: object){
    this.content = val['info']
  }
  action = process.env.NODE_ENV === 'development' ? `/bff-supplier/supplier/file/uploadFile` :`${location.origin}/api/bff-supplier/supplier/file/uploadFile`;
  quillUpdateImg = false;
  imageUrl = null;
  content = '';
  editorOption = {
    placeholder: '',
    theme: 'snow', // or 'bubble'
    modules: {
      toolbar: {
        container: toolbarOptions, // 工具栏
        handlers: {
          image: function (value) {
            if (value) {
              // 触发input框选择图片文件
              (document.querySelector('.avatar-uploader2 input') as any).click();
            } else {
              this.quill.format('image', false);
            }
          },
        },
      }
    }
  };

  uploadHeaders: object = {} //上传请求头

  mounted () {
    let authToken = localStorage.getItem('authToken')
    if (authToken) {
      this.uploadHeaders["Authorization"] = `Bearer ${authToken}`;
    }

    let info=this.$store.state.info;
    if(info){
      this.content=info;
      this.$nextTick(function () {
        let quill = this.$refs.myQuillEditor['quill'];
        // 获取编辑器光标位置
        let index = quill.selection.savedRange.index;
        // 移动光标至文本后面
        quill.setSelection(info.length+1);
      });
    }
  }
  beforeUploadEdit(res, file) {
    const isLt2M = res.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      this.$message.error('上传图片大小不能超过2M');
    }
    if(isLt2M){
      // 显示loading动画
      this.quillUpdateImg = true;
    }
    return isLt2M;
  }
  // 上传图片成功
  uploadSuccessEdit(res, file, fileList) {
    let isSuces = fileList.every(item=>item.response);
    if(isSuces){
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor['quill'];

      fileList.forEach(item=>{
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.data.url为服务器返回的图片地址
        quill.insertEmbed(length, 'image', item['response']['fileUrl']);
        // 调整光标到最后
        quill.setSelection(length + 1);
      })
      // loading动画消失
      this.quillUpdateImg = false;
      (this.$refs.avatarUploader3 as any).clearFiles();
    }
  }
}
